export const getFocalCoordinates = (focalPoint: string) => {
  const [coordinates] = focalPoint.split(':');
  const [x, y] = coordinates.split('x');

  return {
    x,
    y,
  };
};
